function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getgraphData } from '../../services/apiservices';
import Graph from 'vis-react';
import { TextField } from '@material-ui/core';
import Dropdown from '../filter-component/Dropdown';
import { searchNode, clusterNodes, clusterBasedOnId, declusterNodes, highLightEntirePath, unSelectAllEdges } from './vis-network-function';
import { pushOpenedCluster, pushClosedCluster } from '../store/access-graph-slice';
import legendImageData from '../../constants/legend-image-data';
import ToolTip from '../tooltip/tooltip';
import FilterComponent from '../filter-component/filter-component';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AccessGraphWrapper, Legend, AccessGraphComponent, LegendImage, LegendImageWrapper, LegendName, SearchBox, FilterLegend, DropdownStyle, MainCard, StyledAutocomplete, StyledSpinnerDiv, ErrorMessageContainer, ErrorMessage } from './access-graph.styles';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import searchIcon from '../../assets/img/search.svg';
import InputAdornment from '@material-ui/core/InputAdornment';
import lowerCase from 'lodash/lowerCase';
import camelCase from 'lodash/camelCase';
const useStyles = makeStyles(() => ({
  inputRoot: {
    fontFamily: 'OpenSans-Regular',
    fontSize: '12px',
    width: '100%'
  },
  noOptions: {
    fontFamily: 'OpenSans-Regular',
    fontSize: '12px'
  }
}));

const AccessGraph = () => {
  const autoC = useRef(null);
  const clickTimeout = useRef(null);
  const classes = useStyles();
  const {
    nodes,
    edges,
    openClusterIds,
    graphOptions
  } = useSelector(state => state.graph);
  const loaderStatus = useSelector(state => state.graph.loaderStatus);
  const errorMessage = useSelector(state => state.graph.errorMessage);
  const dropdownValue = useSelector(state => state.graph.dropdownValue);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');
  const [tooltipCoordinates, settoolTipCoordinates] = useState({});
  const [toolTipEntity, setTooltipEntity] = useState({});
  const [autoCompleteParams, setAutoCompleteParams] = useState([]);
  const [isEdgeForTooltip, setIsEdgeForTooltip] = useState(false);
  const [allLevels, setAllLevels] = useState([]);
  const clusterIdsFromNodes = nodes.map(node => {
    return node.clusterId;
  });
  const clusterIds = [...new Set(clusterIdsFromNodes)];
  const policyData = useSelector(state => state.accordionData.policy); //to-do

  useEffect(() => {
    let url = `/api/ada/graph/accessmap/ramdetailsbyentitytype?entityType=${camelCase(lowerCase(policyData.objectType))}&key=${policyData.entityUuid}`;
    dispatch(getgraphData(url, dropdownValue));
  }, [dispatch]);
  useEffect(() => {
    if (nodes.length) {
      const params = nodes.map(node => {
        return {
          title: node.fullLabel
        };
      });
      const validParams = params.filter(param => param && param.title);
      const clusterIdParams = clusterIds.filter(el => !openClusterIds.includes(el)).map(clusterId => {
        if (clusterId !== 'userCluster' && clusterId !== 'roleCluster' && clusterId !== 'policyCluster' && clusterId !== 'groupCluster') return {
          title: `${clusterId}(Resource Cluster)`
        };
      });
      const validClusteridParams = clusterIdParams.filter(param => param && param.title);
      setAutoCompleteParams(validParams.concat(validClusteridParams));
      const allLevels = [...new Set(nodes.map(node => node.level).sort())];
      setAllLevels(allLevels);
    } else {
      setAutoCompleteParams([]);
      setAllLevels([]);
    }
  }, [nodes, openClusterIds]);

  const searchTextHandler = (event, newValue) => {
    if (newValue) setSearchText(newValue.title);else setSearchText('');
  };

  const tootltipInfoHandler = toolTipInfo => {
    const x = toolTipInfo.x;
    const y = toolTipInfo.y;
    settoolTipCoordinates({
      x,
      y
    });
    setTooltipEntity(toolTipInfo.toolTipEntity);
    setIsEdgeForTooltip(toolTipInfo.isEdge);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToolTip, {
    x: tooltipCoordinates.x,
    y: tooltipCoordinates.y,
    entityObject: toolTipEntity,
    closeTooltip: () => {
      tootltipInfoHandler({});
    },
    edge: isEdgeForTooltip
  }), /*#__PURE__*/React.createElement(MainCard, null, /*#__PURE__*/React.createElement(FilterLegend, null, /*#__PURE__*/React.createElement(FilterComponent, {
    emptyToolTip: () => {
      settoolTipCoordinates({});
      const ele = autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
      if (ele) ele.click();
    }
  }), /*#__PURE__*/React.createElement(DropdownStyle, null, /*#__PURE__*/React.createElement(Dropdown, null)), /*#__PURE__*/React.createElement(SearchBox, null, /*#__PURE__*/React.createElement(StyledAutocomplete, {
    size: 'small',
    classes: classes,
    id: "flat-demo",
    width: "320px",
    ref: autoC,
    height: "28px",
    options: autoCompleteParams,
    renderOption: option => /*#__PURE__*/React.createElement(Typography, {
      style: {
        fontSize: '12px',
        fontFamily: 'OpenSans-Regular !important',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }, option.title),
    getOptionLabel: option => option.title,
    renderInput: params => {
      params.InputProps.startAdornment = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputAdornment, {
        position: "start",
        style: {
          height: '28px'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: searchIcon,
        style: {
          margin: '0 10px'
        }
      })), params.InputProps.startAdornment);
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          display: 'inline-block',
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement(TextField, _extends({
        type: "search",
        style: {
          fontSize: '12px',
          fontFamily: 'OpenSans-Regular !important',
          textIndent: 30,
          border: '1px solid rgba(0,0,0, 0.250)',
          borderRadius: '4px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        id: "standard-basic"
      }, params, {
        placeholder: "What are you looking for?"
      })));
    },
    onChange: searchTextHandler
  }))), /*#__PURE__*/React.createElement(AccessGraphWrapper, null, /*#__PURE__*/React.createElement(Legend, null, legendImageData.map((legendImageDatum, index) => {
    return /*#__PURE__*/React.createElement(LegendImageWrapper, {
      key: index
    }, /*#__PURE__*/React.createElement(LegendImage, {
      src: legendImageDatum.url,
      alt: "Node Name"
    }), /*#__PURE__*/React.createElement(LegendName, null, legendImageDatum.title));
  })), /*#__PURE__*/React.createElement(AccessGraphComponent, null, !loaderStatus && !errorMessage.length > 0 && /*#__PURE__*/React.createElement(Graph, {
    key: [searchText, allLevels.length],
    className: "graph",
    getNetwork: network => {
      network.moveTo({
        scale: 0.2
      });
      let closedClusterIds = clusterIds.filter(el => {
        return !openClusterIds.includes(el);
      });
      closedClusterIds.forEach(clusterId => {
        clusterBasedOnId(network, clusterId);
      });
      searchNode(network, searchText, allLevels);
      network.on('selectNode', params => {
        let openedCluserId = clusterNodes(network, params);

        if (openedCluserId) {
          dispatch(pushOpenedCluster(openedCluserId));
        }
      });
      network.on('doubleClick', params => {
        if (clickTimeout && clickTimeout.current) {
          clearTimeout(clickTimeout.current);
        }

        unSelectAllEdges(network);
        let closedClusterId = declusterNodes(network, params);

        if (closedClusterId) {
          dispatch(pushClosedCluster(closedClusterId));
          settoolTipCoordinates({});
        }
      });
      network.on('click', event => {
        if (clickTimeout && clickTimeout.current) {
          clearTimeout(clickTimeout.current);
        }

        clickTimeout.current = setTimeout(() => {
          const x = event.event.center.x;
          const y = event.event.center.y;

          if (event.edges.length) {
            if (!event.edges[0].includes('cluster')) {
              const toolTipEntity = network.body.data.edges._data[event.edges[0]].toolTipInfo;
              tootltipInfoHandler({
                x,
                y,
                toolTipEntity,
                isEdge: true
              });
            }
          }

          if (event.nodes.length) {
            const nodeData = network.body.data.nodes._data[event.nodes[0]];

            if (nodeData) {
              const toolTipEntity = nodeData.toolTipInfo;
              tootltipInfoHandler({
                x,
                y,
                toolTipEntity,
                isEdge: false
              });
              highLightEntirePath(network, nodeData, allLevels);
            }
          }

          if (!event.nodes.length && !event.edges.length || event.edges[0].includes('cluster')) {
            settoolTipCoordinates({});
          }
        }, 500);
      });
      network.on('zoom', () => {
        settoolTipCoordinates({});
      });
      network.on('dragging', () => {
        settoolTipCoordinates({});
      });
    },
    graph: {
      nodes: nodes,
      edges: edges
    },
    options: graphOptions
  }), loaderStatus && /*#__PURE__*/React.createElement(StyledSpinnerDiv, null, /*#__PURE__*/React.createElement(CircularProgress, null)), errorMessage.length > 0 && /*#__PURE__*/React.createElement(ErrorMessageContainer, null, /*#__PURE__*/React.createElement(ErrorMessage, null, /*#__PURE__*/React.createElement("div", null, "No data found."), /*#__PURE__*/React.createElement("div", null, "Please try different filter.")))))));
};

export default AccessGraph;